import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import CostCenterList from './CostCenterList';

//redux

const CostCenter = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Empresa', icon: 'icon-building-2' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Centro de Costo' links={breadcrumbLinks} icon={'icon-wallet'} />
					<CostCenterList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default CostCenter;
